<div class="pt-5 pb-3 px-4 d-flex justify-content-between">
  <div class="fs-1 d-flex align-items-center"><a [href]="'http://mockfjards.se' + postalCodeUrl()"><img
        src="assets/images/MockfjardsLogoHeader.png" /></a></div>
  <div class="d-flex align-items-center gap-1">
    <a [href]="'http://mockfjards.se' + postalCodeUrl()" class="d-flex align-items-center gap-1">
      <span><fa-icon [icon]="faAngleLeft"></fa-icon></span>
      <span>Tillbaka</span><span class="d-none d-sm-block"> till mockfjards.se</span>
    </a>
  </div>
</div>